import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class ContractVisitsService {
  constructor(private http: HttpClientService) {}

  public post(contract_visit): Observable<any> {
    return this.http
      .post("/api/contract_visits", contract_visit)
      .pipe(tap((_) => console.log("ContractVisitsService.post: Ok.")));
  }

  public put(contract_visit): Observable<any> {
    return this.http
      .put(`/api/contract_visits/${contract_visit.id}`, contract_visit)
      .pipe(tap((_) => console.log("ContractVisitsService.put: Ok.")));
  }

  public delete(id): Observable<any> {
    return this.http
      .delete(`/api/contract_visits/${id}`)
      .pipe(tap((_) => console.log("ContractVisitsService.delete: Ok.")));
  }

  public updateVisitsBatch(visits): Observable<any> {
    const body = {
      contract_visits: visits,
    };
    return this.http
      .put("/api/contract_visits/update_batch", body)
      .pipe(tap((_) => console.log("ContractVisitsService.updateVisitsBatch: Ok.")));
  }

  public resendSignatureVisitConfirmationEmails(id: number): Observable<any> {
    return this.http
      .post(`/api/contract_visits/${id}/resend_signature_visit_confirmation_emails`, {})
      .pipe(tap(() => console.log("ContractVisitsService.resendSignatureVisitConfirmationEmails: Ok.")));
  }
}
